import React, { useState } from "react";
import Common_Back_Btn from "../../../../../../common/common_components/common_back_btn/Common_Back_Btn";

import "./Measurement_Uncertainty.css"; // We'll style the stepper here
import Measurement from "./measurement/Measurement";
import Ash from "./ash/Ash";
import VM from "./vm/VM";
import GCV from "./gcv/GCV";

function Measurement_Uncertainty() {
  const [step, setStep] = useState(0);

  const steps = ["M%", "Ash%", "VM%", "GCV (Kcal/Kg)"];

  const renderComponent = () => {
    switch (step) {
      case 0:
        return <Measurement onNext={() => setStep(1)} />;
      case 1:
        return <Ash onNext={() => setStep(2)} onCancel={() => setStep(0)} />;
      case 2:
        return <VM onNext={() => setStep(3)} onCancel={() => setStep(1)} />;
      case 3:
        return <GCV onCancel={() => setStep(2)} />;
      default:
        return null;
    }
  };

  return (
    <section className="Imperiality">
      <div className="back_div">
        <Common_Back_Btn backText="Measurement Uncertainty" />
      </div>

      <div className="stepper">
        {steps.map((label, index) => (
          <div key={index} className="step">
            <div className={`step-circle ${index <= step ? "active" : ""}`}>
              {label}
            </div>

            {index < steps.length - 1 && (
              <div className={`step-line ${index < step ? "active" : ""}`} />
            )}
          </div>
        ))}
      </div>

      <div className="imperiality_Form_div">{renderComponent()}</div>
    </section>
  );
}

export default Measurement_Uncertainty;
